import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { actions as LKModalActions } from '../../shared/LKModal'
import { viewFile } from 'src/store/linkedFiles'
import { translateLkMessage } from '../translate'

export const useFileUrl = (FileID, HashSum_FileID_) => {
  const [fileData, setFileData] = useState({
    url: null,
    contentType: null,
  })
  const dispatch = useDispatch()

  const fetchFille = async () => {
    try {
      const fileDetalsResult = await dispatch(
        viewFile({
          FileID,
          HashSum_FileID_,
        }),
      )
      // @ts-ignore
      const payload = fileDetalsResult.payload

      // @ts-ignore
      if (viewFile.fulfilled.match(fileDetalsResult)) {
        setFileData({
          url: payload.url,
          contentType: payload.contentType,
        })
      } else {
        throw payload
      }
    } catch (error) {
      dispatch(
        LKModalActions.openError(translateLkMessage(error), undefined, undefined, () => {
          dispatch(LKModalActions.close('FILE_DETAILS_MODAL'))
        }),
      )
    }
  }

  useEffect(() => {
    if (fileData.url === null) {
      fetchFille().then()
    }
  }, [fileData, dispatch, FileID, HashSum_FileID_])

  return fileData
}
